/* eslint-env browser, jquery */

'use strict';

const ProductBundles =
  window.ProductBundles != null
    ? window.ProductBundles
    : (window.ProductBundles = {});

if (ProductBundles.Views == null) {
  ProductBundles.Views = {};
}

ProductBundles.Views.BundleModal = window.Backbone.View.extend({
  el: '#product-bundles-modal',
  events: {
    'click .add-item': 'addItem',
    'click .details-link': 'toggleMoreDetails',
    'click .no-thanks': 'removeItem',
    'click .t-back-link': 'hideProductBundlesModal',
    'click .product-details a': 'detailLinksInNewPage',
  },
  scrollOffset: 0,
  initialize() {
    this.$dealElem = $('.modal-bundle-deal');
    return this.render();
  },
  setIsTouch(isTouch) {
    this.isTouch = isTouch;
    this.templateDeal = isTouch
      ? require('../../responsive/modal_bundle_deal.html.mustache')
      : require('../../modal_bundle_deal.html.mustache');
  },
  addItem() {
    this.model.set('isSelected', true);
    if (this.isTouch) this.hideProductBundlesModal();
  },
  removeItem() {
    this.model.set('isSelected', false);
    if (this.isTouch) this.hideProductBundlesModal();
  },
  updateProductBundle(productBundle) {
    this.productBundle = productBundle;
    return this.renderBundle();
  },
  renderBundle() {
    this.$dealElem.html(this.templateDeal.render(this.productBundle));
    return this.delegateEvents();
  },
  detailLinksInNewPage(event) {
    event.preventDefault();
    window.open($(event.currentTarget).attr('href'), '_blank');
  },
  hideProductBundlesModal() {
    this.$bodyhtml = this.$bodyhtml || $('body,html');
    this.$mainTouchPane = this.$mainTouchPane || $('#global-container');
    this.$mainTouchPane.show();
    this.$el.hide();
    this.$bodyhtml.animate({ scrollTop: this.scrollOffset }, 'slow');
  },
});

module.exports = ProductBundles.Views.BundleModal;
